/* eslint-disable import/prefer-default-export */
import { put, takeLatest, select } from 'redux-saga/effects';
import { setNotification } from 'utils';
import { push } from 'react-router-redux';
import * as StoreActions from 'redux/actions/storeActions';
import * as StoreAPIs from 'redux/api/storeApi';
import * as StoreTypes from 'redux/types/storeTypes';

const getLayout = state => state.layout;
const getStore = state => state.store;

// L O A D   S T O R E
function* loadStoreSaga() {
    try {
        const store = yield select(getStore);
        const { offset, limit, filters } = store;
        const params = {
            offset,
            limit,
        };

        const filterParams = {};

        if (filters.name !== '') {
            filterParams.name = filters.name.trim();
        }

        if (filters.phone !== '') {
            filterParams.phone = filters.phone.trim();
        }

        if (filters.region !== '') {
            filterParams.region = filters.region.trim();
        }

        if (filters.manager !== '') {
            filterParams.manager = filters.manager.trim();
        }

        if (filters.status !== undefined) {
            filterParams.status = filters.status;
        }

        if (filters.type !== undefined) {
            filterParams.type = filters.type;
        }

        if (filters.language !== undefined) {
            filterParams.language = filters.language;
        }

        params.filter = JSON.stringify(filterParams);

        const result = yield StoreAPIs.getStoreApi(params);

        if (result.status === 200) {
            yield put(StoreActions.loadStoreRes(result.data));
        } else {
            yield put(StoreActions.loadStoreErr());
        }
    } catch (e) {
        yield put(StoreActions.loadStoreErr());
        console.log(e);
    }
}

export function* loadStoreWatcher() {
    yield takeLatest(StoreTypes.LOAD_STORE, loadStoreSaga);
}
// L O A D   S T O R E

// L O A D   E D I T A B L E   S T O R E
function* loadEditableStoreSaga(action) {
    try {
        const store = yield select(getStore);
        const { offset, limit } = store;

        const params = {
            offset,
            limit,
        };

        params.filter = JSON.stringify({ _id: action.id });

        const result = yield StoreAPIs.getStoreApi(params);

        if (result.status === 200) {
            yield put(StoreActions.loadEditableStoreRes(result.data));
        } else {
            yield put(StoreActions.loadEditableStoreErr());
        }
    } catch (e) {
        yield put(StoreActions.loadEditableStoreErr());
        console.log(e);
    }
}

export function* loadEditableStoreWatcher() {
    yield takeLatest(StoreTypes.LOAD_EDITABLE_STORE, loadEditableStoreSaga);
}
// L O A D   E D I T A B L E   S T O R E

// E D I T   S T O R E
function* editStoreSaga(action) {
    try {
        const layout = yield select(getLayout);
        const { locale } = layout;
        const result = yield StoreAPIs.editStoreApi(action.data);

        if (result.status === 202) {
            setNotification('success', locale, 'global.success', 'store.notification.editStore.success');
            yield put(StoreActions.editStoreRes());
            yield put(push('/settings/stores'));
        } else {
            setNotification('error', locale, 'global.error', 'store.notification.editStore.error');
            yield put(StoreActions.editStoreErr());
        }
    } catch (e) {
        console.log(e);
        yield put(StoreActions.editStoreErr());
    }
}
export function* editStoreWatcher() {
    yield takeLatest(StoreTypes.EDIT_STORE, editStoreSaga);
}
// E D I T   S T O R E

// A D D   S T O R E
function* addStoreSaga(action) {   
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const formData = new FormData();
        const dataKeys = Object.keys(action.data);
        dataKeys.forEach((key) => {
            if (key !== 'slides' && key !== 'logo') {
                formData.append(key, action.data[key]);
            }
        });

        if (!action.data.logo || action.data.logo.length === 0) {
            formData.append('logo', '');
        } else if ((action.data.logo) && (action.data.logo[0].url)) {
            formData.append('logo', action.data.logo[0].url);
        } else if ((action.data.logo) && (action.data.logo[0].url === null)) {
            formData.append('logo', '');
        } else if ((action.data.logo) && (action.data.logo[0].originFileObj)) {
            formData.append('logo', action.data.logo[0].originFileObj);
        }

        if ((action.data.slides) && (action.data.slides[0].url)) {
            formData.append('slides[]', action.data.slides[0].url);
        } else if ((action.data.slides) && (action.data.slides[0].url === null)) {
            formData.append('slides', '');
        } else if ((action.data.slides) && (action.data.slides[0].originFileObj)) {
            formData.append('slides[]', action.data.slides[0].originFileObj);
        }

        const result = yield StoreAPIs.addStoreApi(formData);

        if (result.status === 202) {
            setNotification('success', locale, 'global.success', 'store.notification.addStore.success');
            yield put(StoreActions.addStoreRes());
            yield put(push('/settings/stores'));
        } else {
            setNotification('error', locale, 'global.error', 'store.notification.addStore.error');
            yield put(StoreActions.addStoreErr());
        }
    } catch (e) {
        console.log(e);
        yield put(StoreActions.addStoreErr());
    }
}
export function* addStoreWatcher() {
    yield takeLatest(StoreTypes.ADD_STORE, addStoreSaga);
}
// A D D   S T O R E
